// SectionContext.js
import { createContext, useState, useContext, useEffect } from 'react';
import { getItemFromStore, setItemToStore } from '../utils/storage.util';

const SectionContext = createContext();

export const SectionProvider = ({ children }) => {
    const [activeSection, setActiveSection] = useState(() => {
        const savedSection = getItemFromStore('activeSection');
        return savedSection ? JSON.parse(savedSection) : {
            id: '',
            title: '' // Default title
        };
    });

    // Save to localStorage whenever state changes
    useEffect(() => {
        setItemToStore('activeSection', JSON.stringify(activeSection));
    }, [activeSection]);

    return (
        <SectionContext.Provider value={{ activeSection, setActiveSection }}>
            {children}
        </SectionContext.Provider>
    );
};

export const useSection = () => useContext(SectionContext);